import { ThreeGame } from "./three/ThreeGame";

export function GameRenderer() {
  return <ThreeGame />;
}
